module.exports = __webpack_public_path__ + "static/media/3DPPA39.47706e26.jpg";